import Payment from "seneca-common/features/subscriptions/state/models/subscriptions/payment";

export const paymentError = (state: Payment) => state.error;

export const secureCustomerAuthenticationIsOngoing = (state: Payment) =>
  state.secureCustomerAuthenticationOngoing;

export const paymentMethodCreationIsOngoing = (state: Payment) =>
  state.paymentMethodCreationOngoing;
